// Accesso per area: quale area copre ogni indirizzo, chi può leggere o modificare.
// Le chiavi sono le stringhe esatte del backend (vedi PERMISSION_AREAS);
// i permessi effettivi arrivano con l'utente (GET /Authentication → areaPermissions).

export const AREAS = {
	DIREZIONE: "Direzione",
	ANAGRAFICHE: "Anagrafiche",
	ATTIVITA: "Attivita",
	PERFORMANCE: "Performance",
	AREA_MEDICA: "AreaMedica",
	SCOUTING: "Scouting",
	SEGRETERIA: "Segreteria",
	VIDEO: "Video",
	CONFIGURAZIONI: "Configurazioni",
};

const FULL = "FullControl";
const READ = "ReadOnly";

// Prefisso URL → area (il primo che corrisponde vince). Senza area: tutti.
const ROUTE_AREAS = [
	["/ds", AREAS.DIREZIONE],
	["/manager/players-contracts", AREAS.DIREZIONE],
	["/manager/finance", AREAS.DIREZIONE],
	["/manager/market-simulation", AREAS.DIREZIONE],
	["/manager/teams", AREAS.ANAGRAFICHE],
	["/manager/staffs", AREAS.ANAGRAFICHE],
	["/manager/players-comparison", AREAS.ANAGRAFICHE],
	["/players-valuations", AREAS.ANAGRAFICHE],
	["/players", AREAS.ANAGRAFICHE],
	["/calendar", AREAS.ATTIVITA],
	["/matches", AREAS.ATTIVITA],
	["/match-reports", AREAS.ATTIVITA],
	["/trainings", AREAS.ATTIVITA],
	["/match-day", AREAS.ATTIVITA],
	["/exercises", AREAS.ATTIVITA],
	["/competitions", AREAS.ATTIVITA],
	["/measurations", AREAS.PERFORMANCE],
	["/gps", AREAS.PERFORMANCE],
	["/athletic-tests", AREAS.PERFORMANCE],
	["/medical", AREAS.AREA_MEDICA],
	["/scouting", AREAS.SCOUTING],
	["/development", AREAS.SCOUTING],
	["/secretariat", AREAS.SEGRETERIA],
	["/video", AREAS.VIDEO],
	["/settings", AREAS.CONFIGURAZIONI],
	["/import-data", AREAS.CONFIGURAZIONI],
];

export const areaForPath = (pathname = "") => {
	const found = ROUTE_AREAS.find(
		([prefix]) => pathname === prefix || pathname.startsWith(prefix + "/"),
	);
	return found ? found[1] : null;
};

const isAdmin = (user) =>
	["admin", "superuser"].includes(user?.roleName?.toLowerCase());

export const isPlayer = (user) => user?.roleName?.toLowerCase() === "player";

// Livello sull'area: "FullControl", "ReadOnly" o null. L'admin vede tutto.
// "Direzione" finché il backend non la espone resta solo all'admin.
export const accessLevel = (user, area) => {
	if (!area || isAdmin(user)) return FULL;
	const found = (user?.areaPermissions || []).find((p) => p.area === area);
	return found?.accessLevel || null;
};

export const canRead = (user, area) =>
	[FULL, READ].includes(accessLevel(user, area));

export const canWrite = (user, area) => accessLevel(user, area) === FULL;

// Il giocatore non passa dalle aree: vede solo i suoi dati.
export const canOpenPath = (user, pathname) =>
	isPlayer(user) || canRead(user, areaForPath(pathname));

// Home: vista DS per la direzione, altrimenti la prima pagina leggibile.
const HOME_BY_AREA = [
	[AREAS.DIREZIONE, "/ds/oggi"],
	[AREAS.ATTIVITA, "/calendar"],
	[AREAS.ANAGRAFICHE, "/players"],
	[AREAS.PERFORMANCE, "/measurations/wellness"],
	[AREAS.AREA_MEDICA, "/medical/overview"],
	[AREAS.SCOUTING, "/scouting/planning"],
	[AREAS.SEGRETERIA, "/secretariat"],
	[AREAS.CONFIGURAZIONI, "/settings/seasons"],
];

// fullView: home del menu completo (senza la vista DS)
export const homePath = (user, fullView = false) => {
	// Senza scheda collegata il giocatore parte dai suoi allenamenti
	if (isPlayer(user))
		return user.playerId ? "/profile/" + user.playerId : "/trainings";
	const found = HOME_BY_AREA.find(
		([area]) => canRead(user, area) && !(fullView && area === AREAS.DIREZIONE),
	);
	return found ? found[1] : "/messages";
};

// Azioni di inserimento e modifica: spariscono con la sola lettura
const EDIT_ACTION =
	/\b(aggiung|nuov|modific|elimin|crea|importa|carica|assegn|salva|inserisc|registr|gestisci|sposta|rimuovi)/i;

export const readableActions = (actions, writable) =>
	writable
		? actions
		: (actions || []).filter(
				(a) => !EDIT_ACTION.test(`${a?.title || ""} ${a?.label || ""}`),
			);
